import { CalendarEntry } from "Components/Calendar/CalendarEntryHelper";
import moment, { Moment } from "moment";
import { DropAreaPoint } from "../types/DropAreaPoint";

export function getUnblockedDayDropAreaPoints(
	day: Moment,
	points: DropAreaPoint[],
	calendarEntries: CalendarEntry[]
) {
	return points.filter((point) => {
		const pointMoment = day.clone().add(point.minute, "minutes");

		for (const calendarEntry of calendarEntries) {
			const startTime = moment.unix(calendarEntry.startTime);
			const endTime = moment.unix(calendarEntry.endTime);

			if (pointMoment.isAfter(startTime) && pointMoment.isBefore(endTime)) {
				return false;
			}
		}

		return true;
	});
}
